import { jsx as _jsx } from "react/jsx-runtime";
import IconButton from "../../../../../components/atoms/IconButton/index.js";
export const AppBarBreadcrumbsCollapsedIconComponent = ({ onOpenMenu, ariaProps, ...props }) => (_jsx(IconButton, { type: "ellipsis-stroke", ...ariaProps, ...props, component: "div", onClick: onOpenMenu }));
export default AppBarBreadcrumbsCollapsedIconComponent;
